import { constants } from '..';

const setAffiliateLoadingAction = flag => ({
  type: constants.affiliate.SET_AFFILIATE_LOADING,
  flag,
});

const getAffiliateInvitesAction = body => ({
  type: constants.affiliate.GET_AFFILIATE_INVITES,
  body,
});

const setAffiliateInvitesAction = (affiliateInvites, count, header) => ({
  type: constants.affiliate.SET_AFFILIATE_INVITES,
  affiliateInvites,
  count,
  header,
});

const clearAffiliateInvitesAction = () => ({
  type: constants.affiliate.CLEAR_AFFILIATE_INVITES,
});

const exportAffiliateInvitesAction = filename => ({
  type: constants.affiliate.EXPORT_AFFILIATE_INVITES,
  filename,
});

const setAffiliateSettingsLoadingAction = flag => ({
  type: constants.affiliate.SET_AFFILIATE_SETTINGS_LOADING,
  flag,
});

const getAffiliateSettingsAction = () => ({
  type: constants.affiliate.GET_AFFILIATE_SETTINGS,
});

const setAffiliateSettingsAction = settings => ({
  type: constants.affiliate.SET_AFFILIATE_SETTINGS,
  settings,
});

const setAffiliateSettingsSavingAction = flag => ({
  type: constants.affiliate.SET_AFFILIATE_SETTINGS_SAVING,
  flag,
});

const updateAffiliateSettingsAction = (body, onSuccess) => ({
  type: constants.affiliate.UPDATE_AFFILIATE_SETTINGS,
  body,
  onSuccess,
});

export const affiliateActions = {
  setAffiliateLoadingAction,
  getAffiliateInvitesAction,
  setAffiliateInvitesAction,
  clearAffiliateInvitesAction,
  exportAffiliateInvitesAction,
  setAffiliateSettingsLoadingAction,
  getAffiliateSettingsAction,
  setAffiliateSettingsAction,
  updateAffiliateSettingsAction,
  setAffiliateSettingsSavingAction,
};
